import React, { useEffect } from "react";
import "./HeroText.css";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

const HeroText = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 }); //might need to be AOS
  }, []);

  return (
    <div className="container">
      <div className="">
        <div className="col center">
          <div class="wrapper">
            <div class="typing-demo">The Dunning-Kruger Effect</div>

            <div data-aos="fade-down" data-aos-delay="100" className="col">
              <Link to="/play" className="lank">
                Vote
              </Link>
            </div>
            <div data-aos="fade-down" data-aos-delay="50" className="col">
              <a
                href="https://dunningkrugervote.vercel.app"
                className="lank"
                data-toggle="tooltip"
                data-placement="right"
                title="IN PROGRESS - functional, just working on some of the CSS">
                Play
              </a>
            </div>
            <div data-aos="fade-down" data-aos-delay="150" className="col">
              <Link to="/about" className="lank">
                About
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row pad-down">
        <div data-aos="fade-down" data-aos-delay="200" className="col">
          <small className="lank">Rohan Singh</small>
        </div>
      </div>
    </div>
  );
};

export default HeroText;
